import { vRdxUserInfo } from "../../Redux/roStore";
import {
  common_brandbasedgroup_GETROW,
  common_brandgroup_GETROW,
  common_groupstructure_GETROW,
  common_LocationSearch_GETROW,
  common_VendorListReport_GETROW,
  ItemMSP_Location_Api,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

export const HeadObjectInit = {
  sLocation: "Is",
  sMainGroup: "All",
  sSubGroup: "All",
  sCategory: "All",
  sMainSupplier: "All",
  sBrand: "All",
  sItem: "All",
  sCardId: "All",
  sAisle: "All",
  sLevel: "All",
  sBinType: "All",
  sBin: "All",
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sMainGroupArr: [],
  sMainGroupPrnt: "",
  sMainGroupCode: "",
  sMainGroupName: "",
  sSubGroupArr: [],
  sSubGroupPrnt: "",
  sSubGroupCode: "",
  sSubGroupName: "",
  sCategoryArr: [],
  sCategoryPrnt: "",
  sCategoryCode: "",
  sCategoryName: "",
  sMainSupplierArr: [],
  sMainSupplierPrnt: "",
  sMainSupplierCode: "",
  sMainSupplierName: "",
  sSupplierSearchValue: "",
  sBrandArr: [],
  sBrandPrnt: "",
  sBrandCode: "",
  sBrandName: "",
  sBrandSearchValue: "",
  sBrandCategoryArr: [],
  sBrandCategoryPrnt: "",
  sBrandCategoryCode: "",
  sBrandCategoryName: "",
  sItemCode: "",
  sItemName: "",
  sCardIdFrom: "",
  sCardIdTo: "",
  sAisleArr: [],
  sAislePrnt: "",
  sAisleCode: "",
  sAisleName: "",
  sLevelArr: [],
  sLevelPrnt: "",
  sLevelCode: "",
  sLevelName: "",
  sBinTypeArr: [],
  sBinTypePrnt: "",
  sBinTypeCode: "",
  sBinTypeName: "",
  sBinFromCode: "",
  sBinFromName: "",
  sBinToCode: "",
  sBinToName: "",

  //analysis

  sProperty1: "All",
  sProperty1Arr: [],
  sProperty1Prnt: "",
  sProperty1Code: "",
  sProperty1Name: "",
  sProperty2: "All",
  sProperty2Arr: [],
  sProperty2Prnt: "",
  sProperty2Code: "",
  sProperty2Name: "",
  sProperty3: "All",
  sProperty3Arr: [],
  sProperty3Prnt: "",
  sProperty3Code: "",
  sProperty3Name: "",
  sProperty4: "All",
  sProperty4Arr: [],
  sProperty4Prnt: "",
  sProperty4Code: "",
  sProperty4Name: "",
  sAnalysis1: "All",
  sAnalysis1Arr: [],
  sAnalysis1Prnt: "",
  sAnalysis1Code: "",
  sAnalysis1Name: "",
  sAnalysis2: "All",
  sAnalysis2Arr: [],
  sAnalysis2Prnt: "",
  sAnalysis2Code: "",
  sAnalysis2Name: "",
  sAnalysis3: "All",
  sAnalysis3Arr: [],
  sAnalysis3Prnt: "",
  sAnalysis3Code: "",
  sAnalysis3Name: "",
  sAnalysis4: "All",
  sAnalysis4Arr: [],
  sAnalysis4Prnt: "",
  sAnalysis4Code: "",
  sAnalysis4Name: "",
  sAnalysis5: "All",
  sAnalysis5Arr: [],
  sAnalysis5Prnt: "",
  sAnalysis5Code: "",
  sAnalysis5Name: "",
  sAnalysis6: "All",
  sAnalysis6Arr: [],
  sAnalysis6Prnt: "",
  sAnalysis6Code: "",
  sAnalysis6Name: "",
  sAnalysis7: "All",
  sAnalysis7Arr: [],
  sAnalysis7Prnt: "",
  sAnalysis7Code: "",
  sAnalysis7Name: "",
};

export const sWebStockReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];

export const GetLocation = async (setLocationData) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  //v_AnyData,v_Cd,v_Name,v_Distri,v_UserCd
  var vLocobj = {
    // v_AnyData: "",
    // v_Cd: "",
    // v_Name: "",
    // v_Distri: "Y",
    UserCd: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLocobj);
  const vLocation = await ItemMSP_Location_Api(FinalObj);
  console.log("log", vLocation);

  if (vLocation?.status === 200) {
    setLocationData(vLocation?.data?.ResultSet);
  }
};

export const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotBrand = async (setGroupData) => {
  const CurrentMaingroupArr = await common_brandgroup_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};

export const GetWmsStockRepotMainSupplier = async (setGroupData) => {
  const CurrentMaingroupArr = await common_VendorListReport_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const fWmsStockRepotBrandArr = async (
  xGroupStructureObj,
  setGroupData
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};

export const fValidationHead_Client = (HeadObject, validateOnLoad) => {
  if (!validateOnLoad) return true; // ⛔ Skip validation before Load click

  if (
    HeadObject.sLocation?.toUpperCase() === "IS" &&
    !HeadObject.sLocationPrnt
  ) {
    fAlertToast("FAILED", "Location should not be empty");
    return false;
  }

  if (
    HeadObject.sMainGroup?.toUpperCase() === "IS" &&
    !HeadObject.sMainGroupPrnt
  ) {
    fAlertToast("FAILED", "MainGroup should not be empty");
    return false;
  }

  if (
    HeadObject.sSubGroup?.toUpperCase() === "IS" &&
    !HeadObject.sSubGroupPrnt
  ) {
    fAlertToast("FAILED", "sSubGroup should not be empty");
    return false;
  }

  if (
    HeadObject.sCategory?.toUpperCase() === "IS" &&
    !HeadObject.sCategoryPrnt
  ) {
    fAlertToast("FAILED", "sCategory should not be empty");
    return false;
  }

  if (
    HeadObject.sMainSupplier?.toUpperCase() === "IS" &&
    HeadObject?.sMainSupplierArr?.length === 0
  ) {
    fAlertToast("FAILED", "sMainSupplier should not be empty");
    return false;
  }

  if (
    HeadObject.sBrand?.toUpperCase() === "IS" &&
    HeadObject?.sBrandArr?.length === 0
  ) {
    fAlertToast("FAILED", "sBrandCategory should not be empty");
    return false;
  }

  return true;
};
